import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useEffect } from 'react'
import Select from 'react-select'
import { appGetAllSanstha } from '../../store/sanstha'
import { appCreateAnnouncement } from '../../store/announcement'

function NewAnnouncement() {
	const { id } = useParams()
	const dispatch = useDispatch()
	const navigate = useNavigate()

	const { isloder } = useSelector(state => state.annoucementReducer)
	// const { hub } = useSelector((state) => state.hubReducer);
	// const { sanstha } = useSelector((state) => state.sansthaReducer);
	const sansthaId = localStorage.getItem('sansthaId')
	const permissionOfSanstha = localStorage.getItem('permissionOfSanstha')
	const userData = JSON.parse(localStorage.getItem('user') || '{}')
	const hubId = userData.hub

	// const handleHubChange = (option) => {
	//   formik.setFieldValue("hub", option?.value);
	//   dispatch(appGetAllSanstha({ page: 1, limit: 1000, hub: option?.value }));
	// };

	useEffect(() => {
		// dispatch(appGetAllSanstha({ page: 1, limit: 1000, hub: hubId || permissionOfHub }));
		// dispatch(appAllGetHubs({ page: 1, limit: 1000 }));
	}, [dispatch])

	const formik = useFormik({
		initialValues: {
			title: '',
			body: '',
			hub: hubId,
			sanstha: sansthaId || permissionOfSanstha,
		},
		enableReinitialize: true,
		validationSchema: Yup.object({
			body: Yup.string()
				.transform(value => {
					if (!value) return ''
					return value
						.replace(/<[^>]+>/g, '')
						.replace(/&nbsp;/gi, '')
						.trim()
				})
				.test('is-not-empty', 'Body is required', value => value && value.length > 0)
				.required('Body is required'),
			title: Yup.string().required('Post title is required'),
			// hub: Yup.string().required("Community is required"),
			// sanstha: Yup.string().required("Sanstha is required"),
		}),
		onSubmit: values => {
			//  console.log(values);
			const temp_obj = {
				title: values.title,
				body: values?.body,
				sanstha: sansthaId || permissionOfSanstha,
				hub: hubId,
				navigate: navigate,
			}
			//  console.log("temp_obj", temp_obj);
			const filtered_obj = Object.fromEntries(
				Object.entries(temp_obj).filter(
					([key, value]) =>
						value !== '' && value !== null && value !== undefined && key !== 'navigate',
				),
			)
			//   console.log(filtered_obj);
			if (id) {
				// dispatch(appUpdatePost({ ...filtered_obj, id })).then(() => {
				// });
			} else {
				dispatch(appCreateAnnouncement(filtered_obj)).then(() => {
					formik.resetForm()
				})
			}
		},
	})

	return (
		<>
			{isloder && <div className="loading">Loading...</div>}
			<div className="">
				<div className="card card-default">
					<div className="card-body">
						<form onSubmit={formik.handleSubmit}>
							<div className="row">
								<div className="col-md-6">
									<label>
										Title <span className="text-danger">*</span>
									</label>
									<input
										type="text"
										name="title"
										className="form-control"
										value={formik.values.title}
										onChange={formik.handleChange}
										placeholder="Enter title"
									/>
									{formik.touched.title && formik.errors.title && (
										<div className="text-danger">{formik.errors.title}</div>
									)}
								</div>
								<div className="col-md-6">
									<label>
										Body <span className="text-danger">*</span>
									</label>
									<textarea
										className="form-control"
										name="body"
										onChange={formik.handleChange}
										onBlur={formik.handleBlur}
										value={formik.values.body}
										rows="3"
									/>

									{formik.touched.body && formik.errors.body && (
										<div className="text-danger">{formik.errors.body}</div>
									)}
								</div>
							</div>

							<div className="text-center mt-4">
								<button type="submit" className="btn btn-success mr-2">
									<i className="fa fa-check me-1"></i>
									save
								</button>
								<button type="button" className="btn btn-secondary">
									<i className="fa fa-times me-1"></i> Cancel
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</>
	)
}
export default NewAnnouncement
